
























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {CustomProperty} from 'supporter';

@Component
export default class ProductListCustomCheckbox extends Vue {
  @Prop({
    required: false,
    default: function() {
      return [];
    }
  })
  private readonly properties?: CustomProperty[];

  @Prop({
    required: false,
    default: function() {
      return [];
    },
    type: Array
  })
  private readonly incomingCheckedNos?: (string | number)[];

  @Watch('incomingCheckedNos')
  onChange(newVal: (string | number)[]) {
    this.innerCheckedNos = [...newVal];
  }

  public innerCheckedNos: (string | number)[] = [];

  private change() {
    this.$emit('change', this.innerCheckedNos);
  }
}
